import React from 'react';
import * as styles from './styles.scss';

const InnerHtml = ({ html }) => (
    <div
        className={styles.inner}
        dangerouslySetInnerHTML={{ __html: html }}
    />
);

export default InnerHtml;
